"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.intentColors = void 0;
var colors_1 = require("../colors");
exports.intentColors = {
    primary: colors_1.colors.lightBlue,
    success: colors_1.colors.green,
    danger: colors_1.colors.red,
    warning: colors_1.colors.orange,
    gray: colors_1.colors.gray,
};
//# sourceMappingURL=index.js.map